<template>
    <base-card class="job-cta-card">
        <div class="image-holder">
            <lazy-image
                :src="image.src"
                :alt="image.alt"
                :width="image.width"
                :height="image.height"
            />
        </div>

        <div class="content">
            <h3 class="title" v-test:title>
                {{ title }}
            </h3>

            <p
                v-if="text"
                class="text"
                v-test:text
            >
                {{ text }}
            </p>
        </div>

        <b-button
            variant="primary"
            :href="buttonLink"
            rel="noopener"
            target="_blank"
            size="sm"
            class="cta-btn"
            v-test:ctaBtn
        >
            {{ buttonText }}
        </b-button>
    </base-card>
</template>

<script>
    import BaseCard from '../BaseCard/BaseCard';

    export default {
        name: 'job-cta-card',

        components: { BaseCard },

        props: {
            image: {
                type: Object,
                required: true,
            },

            title: {
                type: String,
                required: true,
            },

            text: {
                type: String,
                default: '',
            },

            buttonText: {
                type: String,
                required: true,
            },

            buttonLink: {
                type: String,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .job-cta-card {
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 30px 25px;
        text-align: center;
        height: 100%;
    }

    .image-holder {
        height: 87px;
        margin-bottom: 16px;
    }

    .lazy-image {
        max-height: 100%;
        max-width: 100%;
        height: auto;
        width: auto;
    }

    .content {
        margin-bottom: 1rem;
    }

    .title {
        font-size: rem(25px);
        line-height: rem(30px);

        &:last-child {
            margin-bottom: 0;
        }
    }

    .text {
        font-size: rem(12px);
        line-height: rem(14.4px);
        color: secondary-palette(5);
        margin-bottom: 0;
    }

    .cta-btn {
        margin-top: auto;
    }
</style>
